export function validateAndFormatDate(input: string) {
  const partialRegex = [
    /^$/,
    /^(\d{1})$/,
    /^(0[1-9]|1[0-2])$/,
    /^(0[1-9]|1[0-2])-$/,
    /^(0[1-9]|1[0-2])-(\d{1})$/,
    /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/,
    /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-$/,
    /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-(\d{1,4})$/,
  ];

  for (const regex of partialRegex) {
    if (regex.test(input)) {
      return { isValid: true };
    }
  }

  return { isValid: false };
}
